import {Component, OnInit} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {BillingUser, User, UserService} from '../../user.service';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {NotificationService} from '../../notification.service';
import {DatePipe} from '@angular/common';
import {LicenseService} from '../../license.service';
import {GlobalValidator} from '../../global-validator';
import {Observable} from 'rxjs/Observable';
import {Customer, CustomerService} from '../../customer.service';
import {isNullOrUndefined} from 'util';
import {PhoneNumber, PhoneNumberService} from '../../phone-number.service';
import {ptBrLocale} from 'ngx-bootstrap/locale';
import {defineLocale} from 'ngx-bootstrap/chronos';
import {BsLocaleService} from 'ngx-bootstrap';
import {AccountCode, AccountCodeService} from '../../account-code.service';
import {UUID} from 'angular2-uuid';

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.css']
})
export class UserEditComponent implements OnInit {

  public formGroup: FormGroup;

  public billingFG: FormGroup;

  disableSubmit = false;

  loading = false;

  editing = false;

  invalidId = false;

  formErrors = {};

  customers: Customer[] = null;

  defaultLicenses = new Map<string, string>();

  phones = new Array<PhoneNumber>();

  accountCodes = new Array<AccountCode>();

  // TODO: make a phone component
  actualPhoneType = '';

  actualData = new User('', '', '', '', '', new Array<string>(), true, new Map<string, string>(),
    new Map<string, string>(), new Map<string, string>(), '', '', 0, null, null);

  actualBillingUser = new BillingUser('', '', '', '', false, '');

  validationMessages = {
    'id': {
      'required': 'Email não informado',
      'incorrectMailFormat': 'Email inválido'
    },
    'name': {
      'required': 'Nome não informado'
    },
  };

  defaultCustomer = '';

  changeActualPhoneType(phoneType: string) {
    this.actualPhoneType = phoneType;
  }

  getActualPhoneIcon(): string {
    if (this.actualPhoneType === 'extension') {
      return 'glyphicon glyphicon-earphone';
    }
    if (this.actualPhoneType === 'work_land_line') {
      return 'fa fa-industry';
    }
    if (this.actualPhoneType === 'work_mobile') {
      return 'fa fa-building';
    }
    if (this.actualPhoneType === 'home_land_line') {
      return 'glyphicon glyphicon-home';
    }
    if (this.actualPhoneType === 'home_mobile') {
      return 'glyphicon glyphicon-phone';
    }
    return 'fa fa-question';
  }

  onActualPhoneChange(newPhone: string): void {
    console.log(`received ${newPhone}`);
  }

  constructor(private fb: FormBuilder, public us: UserService, public router: Router, public route: ActivatedRoute,
              public ns: NotificationService, private datePipe: DatePipe, private ls: LicenseService,
              private cs: CustomerService, private pns: PhoneNumberService, private localeService: BsLocaleService,
              private acs: AccountCodeService) {
    this.defaultLicenses.set('users', 'default');
    this.defaultLicenses.set('webDialer', 'default');
  }

  buildForm() {
    this.formGroup = this.fb.group({
      'id': ['', [Validators.required, GlobalValidator.mailFormatValidator]],
      'name': ['', Validators.required],
      'businessRole': ['', Validators.required],
      'site': [''],
      'identifier': [''],
      'password': [''],
      'enabled': [true],
      'expiration': [''],
      'customerId': [this.defaultCustomer, Validators.required],
      'isAdmin': [false]
    });

    this.billingFG = this.fb.group({
      'enableBilling': [false],
      'accountCode': ['']
    })
  }

  disableAddPhone(phone: string): boolean {
    return PhoneNumberService.parse(phone) == null || this.actualPhoneType === '';
  }

  addPhone(phone): void {
    let i = 0;
    while (this.phones.some((p: PhoneNumber) => p.description === (this.actualPhoneType + i)) && i < 10) {
      i++;
    }
    const phoneNumber = PhoneNumberService.parse(phone.value);
    if (phoneNumber != null) {
      this.phones.push(new PhoneNumber('55', phoneNumber.areaCode, phoneNumber.prefix, phoneNumber.extension,
        this.actualPhoneType + i));
      phone.value = '';
    }
  }

  removePhone(phone: PhoneNumber): void {
    this.phones = this.phones.filter((p) => p.description !== phone.description);
  }

  trySave(model, isValid: boolean) {
    if (!isValid) {
      return;
    }
    this.actualData.username = model.id;
    this.actualData.name = model.name;
    this.actualData.enabled = model.enabled;
    this.actualData.businessRole = model.businessRole;
    this.actualData.site = model.site;
    this.actualData.expiration = (new Date(model.expiration)).getTime();
    this.actualData.licenses = this.defaultLicenses;
    this.actualData.customerId = model.customerId;
    this.actualData.identifier = model.identifier;
    console.log(`DEBUG1:${JSON.stringify(this.actualData)}`);
    if (model.isAdmin) {
      if (!this.actualData.hasRole('USER_ADMIN')) {
        this.actualData.roles.push('USER_ADMIN');
      }
    } else {
      if (this.actualData.hasRole('USER_ADMIN')) {
        this.actualData.roles = this.actualData.roles.filter(role => role !== 'USER_ADMIN')
      }
    }
    console.log(`DEBUG2:${JSON.stringify(this.actualData)}`);
    // only updates the password on a new user
    if (this.editing) {
      this.actualData.password = '';
    } else {
      this.actualData.password = model.password;
    }
    this.actualData.phones = {};
    this.phones.forEach((phone) => {
      console.log(`Add Phone: ${JSON.stringify(phone)}`);
      this.actualData.phones[phone.description] = phone.getE164Format();
    });
    if (isNaN(this.actualData.expiration)) {
      this.actualData.expiration = 0;
    }
    this.loading = true;
    this.disableSubmit = true;
    let result: Observable<User>;
    console.log(`Persisting user: ${JSON.stringify(this.actualData)}`);
    if (this.editing) {
      result = this.us.update(this.actualData);
    } else {
      result = this.us.save(this.actualData);
    }
    result.subscribe((u) => {
        console.log(`User saved successfully: ${JSON.stringify(u)}`);
        this.loading = false;
        this.disableSubmit = false;
        this.ns.success(this.actualData.username, 'Salvo com sucesso');
        if (this.editing) {
          this.router.navigateByUrl('/users');
        } else {
          console.log('reseting...');
          this.formGroup.reset();
          this.phones = new Array<PhoneNumber>();
          console.log('reseted...');
          this.router.navigateByUrl('/users_new');
        }
      },
      (error: any) => {
        console.log(`Error saving server!! ${JSON.stringify(error)}`);
        this.ns.error(error.toString(), 'Erro ao salvar');
        this.loading = false;
      });
    return;
  }

  trySaveBilling(model, isValid: boolean) {
    if (!isValid) {
      return;
    }
    console.log(`Saving: ${JSON.stringify(model)}`);
    this.us.setBilling(this.actualData, model.enableBilling).subscribe(value => {
      if (value != null) {
        this.router.navigateByUrl('/users');
      } else {
        console.log(`Error saving billig: ${value}`);
        this.ns.error(value, 'Erro ao salvar');
      }
    }, (error: any) => {
      console.log(`Error saving server!! ${JSON.stringify(error)}`);
      this.ns.error(error.toString(), 'Erro ao salvar');
    }, () => {
      this.loading = false;
    });
  }

  ngOnInit() {
    defineLocale('pt-br', ptBrLocale);
    this.localeService.use('pt-br');
    this.buildForm();
    this.us.currentUser.subscribe((u: User) => {
      if (u && !u.hasRole('ROOT')) {
        console.log(`User dont have the ROOT role, setting customerId:'${u.customerId}'`)
        this.defaultCustomer = u.customerId;
      }
    });
    // console.log(`${JSON.stringify(this.route.params)}`);
    this.route.params.switchMap((params: Params) => {
      const id = params['id'];
      console.log(`Loading data for id:${id}`);
      if (id) {
        return Observable.from([id]);
      } else {
        return Observable.from(['']);
      }
    }).subscribe((id: string) => {
      this.getUserByID(id).subscribe((u: User) => {
        this.updateUser(u)
        this.us.getBillingUser(u.databaseId).subscribe((bu: BillingUser) => {
          this.updateBillingUser(bu);
        }, (error: any) => {
          console.log(`Error looking for billing user(${u.username}): ${JSON.stringify(error)}`);
          this.actualBillingUser = new BillingUser('', u.databaseId, u.username, '', false, u.customerId);
        });
      });
      // this.getCustomerByID(id).subscribe((c: Customer) => this.updateCustomer(c));
    });
    this.cs.getAll().subscribe((customers: Customer[]) => {
      this.customers = customers;
      this.us.isRoot.subscribe(value => {
        if (!value) {
          this.formGroup.controls['customerId'].patchValue(this.defaultCustomer);
        }
      });
    });
    this.formGroup.valueChanges.debounceTime(500).subscribe((data) => this.onValueChanges(data));
    // this.licenseFormGroup.valueChanges.debounceTime(100).subscribe((data) => this.onLicenseValueChanges(data));
    // this.getServersIds();
  }

  getUserByID(id: string): Observable<User> {
    if (id && id !== '') {
      this.editing = true;
      return this.us.findById(id);
    } else {
      return Observable.from([new User('', '', '', '', '', new Array<string>(), true, new Map<string, string>(),
        new Map<string, string>(), new Map<string, string>(), '', '', 0)]);
    }
  }

  updateUser(u: User): void {
    this.actualData = u;
    for (const i in u.phones) {
      // console.log(`Converting ${i}: ${JSON.stringify(u.phones[i])}`);
      const pn = PhoneNumberService.parse(u.phones[i]);
      if (isNullOrUndefined(pn)) {
        console.error(`error trying to convert to Phone Number:${JSON.stringify(u.phones[i])}`);
      } else {
        pn.description = i;
        this.phones.push(pn);
      }
    }
    this.formGroup.controls['id'].patchValue(u.username);
    this.formGroup.controls['name'].patchValue(u.name);
    this.formGroup.controls['enabled'].patchValue(u.enabled);
    this.formGroup.controls['site'].patchValue(u.site);
    this.formGroup.controls['businessRole'].patchValue(u.businessRole);
    this.formGroup.controls['customerId'].patchValue(u.customerId);
    this.formGroup.controls['identifier'].patchValue(u.identifier);
    if (u && u.hasRole('USER_ADMIN')) {
      this.formGroup.controls['isAdmin'].patchValue(true);
    }
    if (!isNullOrUndefined(u.expiration) && u.expiration !== 0) {
      // this.formGroup.controls['expiration'].setValue(this.datePipe.transform(new Date(u.expiration), 'yyyy-MM-dd'));
      this.formGroup.controls['expiration'].patchValue(new Date(u.expiration));

    }
  }

  updateBillingUser(bu: BillingUser) {
    this.actualBillingUser = bu;
    this.billingFG.controls['enableBilling'].patchValue(bu.enableBilling);
    console.log(`BU: ${JSON.stringify(bu)}`);
    this.acs.findByUserIdAndCustomerId(bu.userId, bu.customerId)
      .subscribe(res => this.accountCodes = res);
  }

  onValueChanges(data?: any) {
    const form = this.formGroup;

    this.formErrors = {};

    for (const field in this.validationMessages) {
      const control = form.get(field);
      if (control && control.dirty && !control.valid) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          console.log(`got key ${key}`);
          if (!this.formErrors[field]) {
            this.formErrors[field] = '';
          }
          this.formErrors[field] += messages[key] + '. ';
        }
      }
    }

    console.log(`id value: ${form.get('id').value}`);

    this.us.verifyExists(form.get('id').value).subscribe(
      (result) => {
        this.invalidId = false;
        if (result && !this.editing) {
          if (!this.formErrors['id']) {
            this.formErrors['id'] = '';
          }
          this.invalidId = true;
          this.formErrors['id'] += 'Email já utilizado';
        }
      }
    );

    for (const error in this.formErrors) {
      if (error !== '""') {
        console.log(`Error:${JSON.stringify(this.formErrors[error])}`);
      }
    }
  }

  addAccountCode() {
    const accountCode = this.billingFG.get('accountCode').value;
    console.log(`Adding Account code:${accountCode} for ${this.actualBillingUser.username}`);
    this.acs.save(new AccountCode(UUID.UUID(), this.actualBillingUser.customerId,
      this.actualBillingUser.userId, accountCode, false))
      .subscribe(value => {
        this.accountCodes.push(value);
        this.billingFG.get('accountCode').setValue('');
      });
  }

  removeAccountCode(accountCode: AccountCode) {
    this.acs.delete(accountCode)
      .subscribe(value => {
        this.accountCodes = this.accountCodes.filter(it => it.accountCode !== accountCode.accountCode);
      });
  }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/user/user-edit/user-edit.component.ts